// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pick-calendar[data-v-bab569cc]{height:100%;overflow:auto;background:#fff;padding:8px 12px 16px}.pick-calendar__fc[data-v-bab569cc]{min-height:480px}.pick-calendar[data-v-bab569cc] .fc-event{cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
